import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { Form } from 'providers/Forms';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Container,
  Wrapper,
  Title,
  PasswordInput,
  Button,
  Text,
  Error,
} from './elements';
import { useText } from 'common/hooks';

const deps = {
  oobCode: state.account.oobCode,
  oobError: state.account.oobError,
  form: state.account.resetPasswordForm,
  fieldChanged: sequences`appContainer.fieldChanged`,
  resetPasswordClicked: sequences`account.resetPassword`,
};

export function ResetPasswordForm({
  oobCode,
  oobError,
  fieldChanged,
  resetPasswordClicked,
  form,
  get,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const passwordForm = new Form(form, get) as any;

  return (
    <Container>
      <Wrapper>
        <Title>{t('authentication.create_a_password')}</Title>
        <PasswordInput
          name={'password'}
          onChange={event =>
            fieldChanged({
              field: 'account.resetPasswordForm.password',
              value: event.target.value,
            })
          }
          placeholder={t('authentication.create_a_password')}
          value={passwordForm.password.value}
        />
        <Text>{t('authentication.must_be_8_characters')}</Text>
        {oobError && <Error>{t('account.reset_password.invalid_code')}</Error>}
        <Button
          disabled={!passwordForm.isValid || !oobCode || oobError}
          onClick={() => resetPasswordClicked()}
        >
          {t('authentication.create_password')}
        </Button>
      </Wrapper>
    </Container>
  );
}

export default connect(deps, ResetPasswordForm);
